export default [
    {
        key: 'temp',
        unit: "store.state.unit['temp'].name",
        yText: `${$t('public.temp')}(${"store.state.unit['temp'].name"})`
    },
    {
        key: 'hum',
        unit: "store.state.unit['hum'].name",
        yText: `${$t('public.hum')}(${"store.state.unit['hum'].name"})`
    },
    {
        key: 'volt',
        unit: $t('integration.volts'),
        yText: 'volt(V)'
    },
    {
        key: 'rssi',
        unit: 'dBm',
        yText: 'rssi(dBm)'
    },
    {
        key: 'lqi',
        unit: '',
        yText: 'lqi'
    }
];
